var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d-prZPf1DSffSpdFAlSuY"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["base-placebo@les-transformations-learning-p"]={id:"d-prZPf1DSffSpdFAlSuY"};
      